import { ExternalDriverResponseDto } from '@planning/app/api'
import { EntityItem } from '../base/EntityItem'
import { IEntity } from '../types'

export type IExternalDriverItem = IEntity<ExternalDriverResponseDto>

export class ExternalDriverItem
  extends EntityItem<ExternalDriverResponseDto>
  implements IExternalDriverItem {}
